export type DeviceTypeData = {
  device_type: string
  sessions: number
  sessions_rate: number
  completions: number
  completions_rate: number
}

export const MOCK_DEVICE_TYPE_DATA = (): DeviceTypeData[] => {
  return Array.from({ length: 2 }, (_, index) => ({
    device_type: `Device ${index + 1}`,
    sessions: 1,
    sessions_rate: 100,
    completions: 0,
    completions_rate: 0,
  }))
}
